import css from 'styled-jsx/css';

const style = css`
  .timeline-wrapper {
    margin: 0 24px 24px 8px;
  }
`;

export default style;
